import React, { Component } from 'react';
import { connect } from 'dva';
import { Modal, Button } from 'antd';
import moment from 'moment';
import SelectUser from 'nbugs-select-user-result-v4.0'
import { kindergartenClass, primarySchoolClass, middleSchoolClass } from '../../../utils/classData';
import styles from './index.less';

@connect(({ createChapterCourse, user }) => ({
  ...createChapterCourse,
  currentUser: user.currentUser,
}))

class PublishModal extends Component {
  componentDidMount() { }

  hideModal = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'createChapterCourse/saveState',
      payload: { publishModalVisible: false },
    });
  };

  saveArticle = () => {
    const { handleOk } = this.props;
    handleOk();
    this.hideModal();
  };

  studentList = () => {
    const { student } = this.props;
    const allData = kindergartenClass.concat(primarySchoolClass).concat(middleSchoolClass);
    const data = []
    allData.forEach(item => {
      student.forEach(id => {
        if (id === item.key) {
          data.push(item.name)
        }
      })
    })

    return data.toString()

  }

  render() {
    const { publishModalVisible, values, currentUser } = this.props;
    const { name } = currentUser;

    const {
      selectId,
      needPush,
      isTiming,
      timingPushTimeString,
    } = values;
    const remindMessage = {
      '1': '是',
      '0': '否',
    };

    const selectUserProps = {
      multiple: true,
      selectType: "dept",
      strictOrgRel: true,
      showTabList: ['orgRel'],
      selectSignature: selectId,
      isSaveSelectSignature: true,
      requestParams: {
        strictUser: true,
        selectTypeList: ['org_rel'],
      }
    };


    return (
      <Modal
        title="确认发布"
        visible={publishModalVisible}
        className={styles['publish-modal']}
        width={650}
        centered
        maskClosable={false}
        onCancel={this.hideModal}
        footer={[
          <Button onClick={this.hideModal}>取消</Button>,
          <Button type="primary" onClick={() => this.saveArticle('submit')}>
            确认发布
          </Button>,
        ]}
      >

        <SelectUser key={new Date()} selectUserProps={selectUserProps} />
        <div className='selece-people'>
          <div>学生：<span>{this.studentList()}</span></div>
          <div>教职工</div>
        </div>

        <div className="attribute">
          <div className="title">属性</div>
          <div className="attribute-container">
            <div className="attribute-item">
              <span>发布者：</span>
              <span>{name || '-'}</span>
            </div>

            <div className="attribute-item">
              <span>消息提醒：</span>
              <span>{remindMessage[needPush]}</span>
            </div>

            {
              Number(needPush) === 1 && (
                <div className="attribute-item">
                  <span>提醒时间：</span>
                  <span>{Number(isTiming) === 0 ? '立即发送' : moment(timingPushTimeString).format("YYYY.MM.DD HH:mm")}</span>
                </div>
              )
            }

          </div>
        </div>
      </Modal>
    );
  }
}
export default PublishModal;
